
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M230.346 199.4l25.868 118.737L282.083 199.4z"}}),_c('path',{attrs:{"d":"M368.265 45.863C337.318 15.492 296.353-.757 252.998.027 210.388.826 170.655 17.94 141.12 48.22c-29.548 30.292-45.651 70.441-45.341 113.052.263 36.092 12.85 71.133 35.444 99.138 25.261 31.312 40.058 70.05 42.233 108.597h66.338l-39.377-180.483c-.869-3.988.116-8.028 2.676-11.207 2.561-3.18 6.424-4.899 10.507-4.899h85.231c4.082 0 7.946 1.849 10.507 5.028s3.545 7.09 2.676 11.078l-39.377 180.483h65.874c2.201-38.547 17.09-77.271 42.502-108.921 22.707-28.282 35.213-63.631 35.213-100.002 0-43.303-17.033-83.866-47.961-114.221zM173.767 395.989v48.065c0 20.895 16.98 38.023 37.875 38.023h6.203c4.416 16.704 20.04 29.923 38.583 29.923s34.168-13.219 38.583-29.923h5.308c20.895 0 37.915-17.128 37.915-38.023v-48.065H173.767z"}})])
          )
        }
      }
    